import React, { useState } from "react";

const dataList = [
  {
    title: "General",
    options: [
      "Fever",
      "Fatigue",
      "Weight Loss",
      "Weight Gain",
      "Night Sweats",
    ],
    name: "general",
  },
  {
    title: "Respiratory",
    options: [
      "Cough",
      "Wheezing",
      "Shortness of breath",
    ],
    name: "respiratoryReview",
  },
  {
    title: "Gastrointestinal",
    options: [
      "Constipation",
      "Acid Reflux",
      "Abdominal Cramps",
      "Diarrhea",
      "Nausea/Vomiting",
      "Hernia",
    ],
    name: "gastrointestinalReview",
  },
  {
    title: "Musculoskeletal",
    options: [
      "Back Pain",
      "Neck Pain",
      "Joint Pains",
      "Muscle Spasms",
      "Joint Stiffness",
      "Joint Swelling",
    ],
    name: "musculoskeletalReview",
  },
  {
    title: "Genitourinary/Nephrology",
    options: [
      "Flank Pain",
      "Decreased Urine Flow/Frequency/Volume",
      "Blood in Urine",
      "Painful Urination",
    ],
    name: "genitourinaryNephrology",
  },
  {
    title: "Neurological",
    options: [
      "Dizziness",
      "Headaches",
      "Seizures",
      "Tremors",
      "Numbness/Tingling",
    ],
    name: "neurologicalReview",
  },
  {
    title: "Psychiatric",
    options: [
      "Depressed Mood",
      "Feeling Anxious",
      "Stress Problems",
      "Suicidal Thoughts",
      "Suicidal Planning",
      "Thoughts of Harming Others",
    ],
    name: "psychiatricReview",
  },
  {
    title: "Ears/Nose/Throat/Neck",
    options: [
      "Dental Problems",
      "Earaches",
      "Hearing Problems",
      "Sinus problems",
    ],
    name: "ENT",
  },
  {
    title: "Cardiovascular",
    options: [
      "Chest Pain",
      "Bleeding Disorder",
      "Blood Clots",
      "Fainting",
      "Palpitations",
      "Swelling in feet",
      "Shortness of breath during sleep",
    ],
    name: "cardiovascular",
  },
  {
    title: "Eyes",
    options: ["Recent Visual changes"],
    name: "eyes",
  },
];

export const ReviewOfSystems = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "checkbox") {
      const currentValue = patientMedicationInfo[name] || [];
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      const isChecked = currentArray.includes(value);
      
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: isChecked
          ? currentArray.filter((item) => item !== value)
          : [...currentArray, value],
      });
    } else {
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: value,
      });
    }
  };
  return (
    <div className=" flex flex-col gap-6 mb-6">
      <div className="flex flex-col gap-5 2xl:w-[70%] xl:w-[70%] lg:w-[70%] md:w-[80%] w-[100%] bg-white p-5 shadow-sm rounded">
        {dataList.map((list, id) => (
          <AccordionItem
            key={id}
            index={id}
            title={list.title}
            checkList={list.options}
            isOpen={openIndex === id}
            onToggle={handleToggle}
            name={list.name}
            handleOnChange={handleOnChange}
            patientMedicationInfo={patientMedicationInfo}
          />
        ))}
      </div>
      
      <div className="my-5 flex flex-col gap-8 p-6 py-10 w-full 2xl:w-[70%] xl:w-[70%] lg:w-[70%] md:w-[80%] w-[100%] bg-white shadow-sm rounded border border-[#d4d4d4]">
        <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
          All other review of systems negative?
        </p>
        <div className="flex justify-start items-center gap-4">
          <button
            onClick={() => {
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                allOtherReviewNegative: "Yes",
                allOtherReviewNegativeText: "", // Clear text when Yes is selected
              });
            }}
            className={`text-[#333333] ${
              patientMedicationInfo.allOtherReviewNegative === "Yes"
                ? "text-[#fff] BTNGradientBg"
                : "text-black bg-white"
            }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
          >
            Yes
          </button>
          <button
            onClick={() => {
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                allOtherReviewNegative: "No",
              });
            }}
            className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
              patientMedicationInfo.allOtherReviewNegative === "No"
                ? "text-[#fff] BTNGradientBg"
                : "text-black bg-white"
            }`}
          >
            No
          </button>
        </div>
        
        {patientMedicationInfo.allOtherReviewNegative === "No" && (
          <div className="mt-4">
            <label className="block font-mainFont font-[500] text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[2.3vw] text-[3.5vw] mb-2">
              Please specify the symptoms:
            </label>
            <textarea
              name="allOtherReviewNegativeText"
              value={patientMedicationInfo.allOtherReviewNegativeText || ""}
              onChange={handleOnChange}
              placeholder="Enter symptoms..."
              className="w-full px-6 py-3 rounded-lg border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0] min-h-[100px] resize-y"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const AccordionItem = ({
  title,
  checkList,
  isOpen,
  index,
  onToggle,
  name,
  handleOnChange,
  patientMedicationInfo
}) => {
  return (
    <>
      <div className="bg-transparent">
        <button
          style={{
            background: isOpen ? "#24518B" : "transparent",
            color: isOpen ? "#fff" : "#0C0544",
          }}
          className={`flex flex-col justify-start items-start w-full gap-4 py-4 border-b border-[#d4d4d4] ${
            isOpen ? "px-8 rounded-full border-b-0" : "px-4 rounded-none "
          } text-left  focus:outline-none  transition-all duration-300 ease-linear`}
          onClick={() => onToggle(index)}
        >
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-[700] font-mainFont 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] ${
                isOpen ? "text-[#fff]" : "text-[#333333]"
              }`}
            >
              {title}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`w-5 h-5 transition-transform duration-500 ${
                isOpen ? "transform rotate-180" : ""
              }`}
            >
              <path
                d="M13.9999 3.33326L1.99994 3.33326C1.87845 3.33364 1.75936 3.36715 1.65549 3.43018C1.55163 3.49321 1.46692 3.58337 1.41048 3.69097C1.35404 3.79856 1.32802 3.9195 1.33521 4.04079C1.3424 4.16207 1.38253 4.27909 1.45128 4.37926L7.45128 13.0459C7.69994 13.4053 8.29861 13.4053 8.54794 13.0459L14.5479 4.37926C14.6174 4.2793 14.6581 4.16222 14.6657 4.04073C14.6733 3.91925 14.6474 3.79801 14.5909 3.69019C14.5344 3.58237 14.4495 3.49209 14.3453 3.42917C14.2411 3.36624 14.1217 3.33307 13.9999 3.33326Z"
                fill={isOpen ? "white" : "#0A1E44"}
              />
            </svg>
          </div>
        </button>
        <div
          className={`overflow-hidden transition-all duration-500 ease-linear ${
            isOpen ? "max-h-[75dvh]" : "max-h-0"
          }`}
        >
          <div className="p-6 bg-transparent flex flex-col gap-4">
            {checkList.map((cur, id) => (
              <>
                <div className="flex justify-start items-center gap-3">
                  <input
                    name={name}
                    type="checkbox"
                    id={`section${index + 1}_${id}`}
                    value={cur}
                    onChange={handleOnChange}
                    checked={Array.isArray(patientMedicationInfo[name]) 
                      ? patientMedicationInfo[name].includes(cur) 
                      : false}
                  />
                  <label
                    htmlFor={`section${index + 1}_${id}`}
                    className="font-mainFont font-[400] text-[#333333] 2xl:text-[1.2vw] xl:text-[1.2vw] lg:text-[1.2vw] md:text-[2.3vw] text-[3.5vw]"
                  >
                    {cur}
                  </label>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
